import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconX = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-x' + (className ? ` ${className}` : '')}
            fill={fill}
            height='15'
            viewBox='0 0 15 13'
            width='13'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M4.47865 0H0L5.31013 6.95589L0.339691 12.791H2.63618L6.39549 8.37773L9.73359 12.7505H14.2122L8.74783 5.59244L8.75751 5.60479L13.4624 0.0812578H11.166L7.67198 4.18311L4.47865 0ZM2.47214 1.2182H3.8664L11.7401 11.5322H10.3458L2.47214 1.2182Z'
                fill={fill}
                fillRule='evenodd'/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconX;
